import DrawerPreviousNext from "components/form/DrawerPreviousNext";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import Error from "components/form/Error";
import SelectCityAll from "components/form/SelectCityAll";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import InputValue from "components/form/InputValue";
import Title from "components/form/Title";
import useSalesSubmit from "hooks/useSalesSubmit";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import ActiveButton from "components/form/ActiveButton";
import { Select } from "@windmill/react-ui";
import Uploader from "components/image-uploader/Uploader";
import SelectStateSingle from "components/form/SelectStateSingle";
import InputMobileWoCode from "components/form/InputMobileWoCode";
import SelectTransHead from "components/form/SelectTransHead";
import DrawerPreviousUpdate from "components/form/DrawerPreviousUpdate";
import UploaderCrop from "components/image-uploader/UploaderCrop";
import Selectseller from "components/form/SelectSeller";
import InputName from "components/form/InputName";
import { FiX } from "react-icons/fi";
import SelectRegType from "components/form/SelectRegType";

// Reusable FormField component to reduce duplication
const FormField = ({
  label,
  required,
  children,
  error,
  className = "col-span-6",
}) => (
  <div className={className}>
    <LabelArea required={required} label={label} />
    {children}
    <Error errorName={error} />
  </div>
);

const SalessDrawer = ({ id }) => {
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    handleNextStep,
    handlePreviousStep,
    errors,
    goToStep,
    step,
    panUrl,
    setPanUrl,
    gstUrl,
    setGstUrl,
    rcUrl,
    setRcUrl,
    logoUrl,
    setLogoUrl,
    loading,
    selectedCity,
    selectedState,
    selectedTitle,
    selectedCompanyType,
    selectedTransHead,
    selectedCompanyTypeName,
    setSelecetedCompanyTypeName,
    setSelectedTransHead,
    handleCityChange,
    handleStateChange,
    setselectedTitle,
    setSelectedCompanyType,
    seller,
    selectedSalesType,
    setSeller,
  } = useSalesSubmit(id);

  const handleCancelImage = (value) => {
    if (value === "gst") setGstUrl("");
    else if (value === "pan") setPanUrl("");
    else if (value === "rc") setRcUrl("");
    else if (value === "logo") setLogoUrl("");
  };

  return (
    <>
      <div className="w-full relative p-3 bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200">
        {id ? <Title title="Update Saless" /> : <Title title="Add Saless" />}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:bg-gray-700 dark:border-gray-600">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <ActiveButton
              tabValue={1}
              labelName="Basic Details"
              goToStep={goToStep}
              step={step}
            />
          </li>
          <li className="mr-2">
            <ActiveButton
              tabValue={2}
              labelName="Company Info"
              goToStep={goToStep}
              step={step}
            />
          </li>
          <li className="mr-2">
            <ActiveButton
              tabValue={3}
              labelName="ID Proof Details"
              goToStep={goToStep}
              step={step}
            />
          </li>
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative bg-white dark:bg-gray-900 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-5 pt-5 flex-grow w-full max-h-full pb-20">
            {step === 1 && (
              <>
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <FormField
                    label="Title"
                    required
                    error={errors.name_title}
                  >
                    <Select
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      {...register("name_title", {
                        required: "Title is required!",
                      })}
                      label="Title"
                      name="name_title"
                      value={selectedTitle}
                      onChange={(e) => setselectedTitle(e.target.value)}
                      onBlur={() => trigger("name_title")}
                      aria-required="true"
                    >
                      <option value="Mr.">Mr.</option>
                      <option value="Ms.">Ms.</option>
                      <option value="Mrs.">Mrs.</option>
                    </Select>
                  </FormField>

                  <FormField
                    label="Name"
                    required
                    error={errors.name}
                  >
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Full Name"
                      name="name"
                      type="text"
                      placeholder="Jhon"
                      pattern={/^[a-zA-Z\s]+$/}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Email"
                    required
                    error={errors.email_id}
                  >
                    <InputValue
                      trigger={trigger}
                      register={register}
                      label="Email"
                      name="email_id"
                      type="text"
                      placeholder="jhon@gmail.com"
                      pattern={/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Contact Number"
                    required
                    error={errors.mobile_no}
                  >
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      label="Mobile Number"
                      name="mobile_no"
                      type="text"
                      minLength={10}
                      maxLength={10}
                      placeholder="9887564789"
                      pattern={/^\d{10}$/}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Alternate Contact Number (Optional)"
                    error={errors.al_mobile_no}
                  >
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      label="Alternate Contact Number"
                      name="al_mobile_no"
                      type="text"
                      required={false}
                      minLength={10}
                      maxLength={10}
                      placeholder="9992787897"
                      pattern={/^\d{10}$/}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                    />
                  </FormField>

                  <FormField
                    label="Key Manager"
                    required
                    error={errors.transport_head_id}
                  >
                    <SelectTransHead
                      register={register}
                      label="Key Manager"
                      name="transport_head_id"
                      selectedTransHead={selectedTransHead}
                      setSelectedTransHead={setSelectedTransHead}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Seller"
                    required
                    error={errors.seller}
                  >
                    <Selectseller
                      register={register}
                      label="Seller"
                      name="seller"
                      selectedTransHead={seller}
                      setSelectedTransHead={setSeller}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>
                </div>
                <DrawerCancelNext handleNextStep={handleNextStep} />
              </>
            )}
            {step === 2 && (
              <>
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <FormField
                    label="Company Type"
                    required
                    error={errors.type_of_company}
                  >
                    <SelectRegType
                      register={register}
                      label="Company Type"
                      name="type_of_company"
                      selectedTransHead={selectedCompanyType}
                      selectedCompanyTypeName={selectedCompanyTypeName}
                      setSelecetedCompanyTypeName={setSelecetedCompanyTypeName}
                      setSelectedTransHead={setSelectedCompanyType}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Company Name"
                    required
                    error={errors.company_name}
                  >
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Company Name"
                      name="company_name"
                      type="text"
                      placeholder="Company name"
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Company Address"
                    required
                    error={errors.address}
                  >
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Company Address"
                      name="address"
                      type="text"
                      placeholder="123 Main Street, City, State"
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="State"
                    required
                    error={errors.state}
                  >
                    <SelectStateSingle
                      register={register}
                      label="State"
                      name="state"
                      selectedCountryId={110} // TODO: Make dynamic
                      selectedState={selectedState}
                      handleStateChange={handleStateChange}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="City"
                    required
                    error={errors.city}
                  >
                    <SelectCityAll
                      register={register}
                      label="City"
                      name="city"
                      selectedState={selectedState}
                      selectedCity={selectedCity}
                      handleCityChange={handleCityChange}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>

                  <FormField
                    label="Pincode"
                    required
                    error={errors.pincode}
                  >
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Pincode"
                      name="pincode"
                      type="number"
                      placeholder="606889"
                      maxLength={6}
                      pattern={/^\d{6}$/}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                  </FormField>
                </div>
                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 3 && (
              <>
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <FormField
                    label="PAN Number"
                    required
                    error={errors.pan_no}
                  >
                    <InputArea
                      trigger={trigger}
                      register={register}
                      required={true}
                      label="PAN Number"
                      name="pan_no"
                      capitalize={true}
                      type="text"
                      placeholder="PAN Number"
                      pattern={/[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                      aria-required="true"
                    />
                    <span className="text-sm text-gray-600 dark:text-gray-400">
                      eg. ABCTY1234D
                    </span>
                  </FormField>

                  <FormField
                    label="PAN Image"
                    required
                    error={errors.panUrl}
                  >
                    {panUrl ? (
                      <div className="relative inline-block max-w-full w-[358px] h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                      <img
                        className="object-contain rounded-lg h-48 w-full max-w-md bg-gray-100"
                        src={process.env.REACT_APP_API_IMAGE_URL + panUrl}
                        alt="PAN"
                      />
               <FiX
                  size={20}
                  style={{ top: '0.5rem', right: '0.5rem', position: 'absolute' }} // ≈ top-2, right-2
                  className="cursor-pointer p-1 rounded-full bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-400 shadow-sm"
                  onClick={() => handleCancelImage("pan")}
                  onKeyDown={(e) => e.key === "Enter" && handleCancelImage("pan")}
                  tabIndex={0}
                  aria-label="Remove PAN image"
                />

                    </div>

                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="Saless"
                        name_merge="Sales_PAN"
                        imageUrl={panUrl}
                        setImageUrl={setPanUrl}
                        no_of_image={1}
                      />
                    )}
                  </FormField>

                  {selectedCompanyTypeName
                    .trim()
                    .toLowerCase()
                    .replace(/\s+/g, "") !== "noncompany" && (
                    <>
                      <FormField
                        label="GST No (Optional)"
                        error={errors.gst_no}
                      >
                        <InputArea
                          trigger={trigger}
                          register={register}
                          required={false}
                          label="GST No"
                          name="gst_no"
                          type="text"
                          capitalize={true}
                          placeholder="22AAAAA0000A1Z5"
                          pattern={/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[0-9]{1}[Z]{1}[A-Z\d]{1}$/}
                          className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 border-gray-300 focus:bg-white"
                        />
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          eg. 22AAAAA0000A1Z5
                        </span>
                      </FormField>

                      <FormField
                        label="GST Image (Optional)"
                        error={errors.gstUrl}
                      >
                        {gstUrl ? (
                                <div className="relative inline-block max-w-full w-[358px] h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                           <img
                         className="object-contain rounded-lg h-48 w-full max-w-md bg-gray-100"
                              src={process.env.REACT_APP_API_IMAGE_URL + gstUrl}
                              alt="GST"
                            />
                            <FiX
                              size={20}
                              style={{ top: '0.5rem', right: '0.5rem', position: 'absolute' }} 
                              className="cursor-pointer p-1 rounded-full bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-400 shadow-sm"
                              onClick={() => handleCancelImage("gst")}
                              onKeyDown={(e) => e.key === "Enter" && handleCancelImage("gst")}
                              tabIndex={0}
                              aria-label="Remove GST image"
                            />
                          </div>
                        ) : (
                          <Uploader
                            is_multiple={false}
                            folder="Saless"
                            name_merge="Sales_GST"
                            imageUrl={gstUrl}
                            setImageUrl={setGstUrl}
                            no_of_image={1}
                          />
                        )}
                      </FormField>

                      <FormField
                        label="Company Registration (Optional)"
                        error={errors.rcUrl}
                      >
                        {rcUrl ? (
                         <div className="relative inline-block max-w-full w-[358px] h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                       <img
                        className="object-contain rounded-lg h-48 w-full max-w-md bg-gray-100"
                              src={process.env.REACT_APP_API_IMAGE_URL + rcUrl}
                              alt="Registration"
                            />
                            <FiX
                              size={20}
                             style={{ top: '0.5rem', right: '0.5rem', position: 'absolute' }} 
                               className="cursor-pointer p-1 rounded-full bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-400 shadow-sm"
                              onClick={() => handleCancelImage("rc")}
                              onKeyDown={(e) => e.key === "Enter" && handleCancelImage("rc")}
                              tabIndex={0}
                              aria-label="Remove company registration image"
                            />
                          </div>
                        ) : (
                          <Uploader
                            is_multiple={false}
                            folder="Saless"
                            name_merge="Sales_COM_CER"
                            imageUrl={rcUrl}
                            setImageUrl={setRcUrl}
                            no_of_image={1}
                          />
                        )}
                      </FormField>

                      <FormField
                        label="Company Logo (Optional)"
                        error={errors.logoUrl}
                      >
                        {logoUrl ? (
                          <div className="relative inline-block max-w-full w-[358px] h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                         <img
                         className="object-contain rounded-lg h-48 w-full max-w-md bg-gray-100"
                              src={process.env.REACT_APP_API_IMAGE_URL + logoUrl}
                              alt="Logo"
                            />
                            <FiX
                              size={20}
                               style={{ top: '0.5rem', right: '0.5rem', position: 'absolute' }} 
                                className="cursor-pointer p-1 rounded-full bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-400 shadow-sm"
                              onClick={() => handleCancelImage("logo")}
                              onKeyDown={(e) => e.key === "Enter" && handleCancelImage("logo")}
                              tabIndex={0}
                              aria-label="Remove company logo"
                            />
                          </div>
                        ) : (
                          <UploaderCrop
                            is_multiple={false}
                            folder="Saless"
                            name_merge="Sales_LOGO"
                            imageUrl={logoUrl}
                            setImageUrl={setLogoUrl}
                            no_of_image={1}
                          />
                        )}
                      </FormField>
                    </>
                  )}
                </div>
                <DrawerPreviousUpdate
                  isSubmitting={loading}
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default SalessDrawer;